// extracted by mini-css-extract-plugin
export default {"container":"Inset--container--XsQ38","transparent":"Inset--transparent--EMbfg"};